module.exports = {
    login:'Se connecter',
    loginByAccount:'Numéro de compte login',
    inputAccount: 'Entrez le numéro de compte',
    inputPassword: 'Entrez le mot de passe',
    verificationCode:'Code de vérification',
    forgotPassword:'Mot de passe oublié',
    experience:'Expérience sans inscription',
    loginTitle1:'Opération facile',
    loginTitle2:'Détails du processus',
    loginTitle3:'Financièrement précis',
    loginTitle4:'Présentation intuitive des données',
    lastTime:'Dernière heure de connexion',
    waitTodo:'Le pense-bête',
    remember:'Mémoriser le mot de passe',
    //按钮
    search:'recherche',
    reset:'réinitialiser',
    add:'ajouter',
    save:'économisez',
    templateDownload:'Télécharger le modèle',
    importGoods:'Marchandises d’importation',
    addGoods:'Ajouter des marchandises',
    edit:'éditer',
    delete:'supprimer',
    copy:'copier',
    examine:'examiner',
    revocation:'révocation',
    confirm:'confirmer',
    inStorage:'Dans le stockage',
    outStorage:'déstockage',
    print:'Imprimer',
    exportDocument:'Exporter le Document',
    saveDraft:'Enregistrer le Brouillon',
    close:'Fermer',
    reject:'Rejeter',
    createNewProduct:'Créer un Nouveau Produit',
    approved:'Approuvé',
    historicalSalesPrice:'Prix de Vente Historique',
    historicalPurchasePrice:'Prix d`Achat Historique',
    export:'Exporter',
    generateInboundOrder:'Générer un Bon de Réception',
    cancle:'Annuler',
    confirmInbound:'Confirmer l`Entrée',
    confirmOutbound:'Confirmer la Sortie',
    EorD:'Activer/Désactiver',
    batchImport:'Importation en Lot',
    batchEdit:'Modification en Lot',
    enable:'Activer',
    disable:'Désactiver',
    inquiryRecords:'Historique des Demandes de Prix',
    barcode:'Code-barres',
    //表格
    No:'No.',
    documentNumber:'Numéro du document',
    warehouse:'Les entrepôts',
    supplier:'fournisseur',
    supplierInformation: 'Information du fournisseur',
    client:'Les clients',
    commodityAmount:'Montant des marchandises',
    otherAmount:'Autres montants',
    totalAmount:'Montant du total',
    status:'l’état',
    createTime:'Temps de création',
    completionTime:'Délai de réalisation',
    startTime:'Heure de début',
    endTime:'Heure de fin',
    operator:'Ouvrir un solo',
    approver:'Approuvé par',
    deliveryTime: 'Délai de livraison',
    remark:'remarques',
    operate:'opérations',
    goodsName:'Nom des marchandises',
    goodsId:'Id des marchandises',
    brand:'Marque de commerce',
    category:'Catégorie de produits',
    select:'sélectionner',
    amountPayable:'Montant à payer',
    amountReceivable:'Montant à recevoir',
    paymentMethod:'Modes de paiement',
    quantity:'Le nombre de',
    unitPrice:'Le prix unitaire',
    amount:'Le montant de',
    storageLocation:'Emplacement de stockage',
    unit:'unité',
    internalCode:'Le code interne',
    specification:'spécification',
    approvalComments:'Commentaires d`Approbation',
    details:'Détails',
    inventoryQuantity:'Quantité en Stock',
    historicalPrice:'Prix Historique',
    amountPaid:'Montant Payé',
    creator:'Créateur',
    phoneNum:'Numéro de Téléphone Portable',
    customerInformation:'Informations Client',
    basicInformation:'Informations de Base',
    contactPerson:'Personne de Contact',
    image:'Image',
    retailPrice:'Prix de Vente au Détail',
    wholesalePrice:'Prix de Gros',
    otherPrice:'Autres Prix',
    foreignName:'Nom Étranger',
    itemLength:'Longueur(mm)',
    itemWide:'Largeur(mm)',
    itemHigh:'Hauteur(mm)',
    itemWeight:'Poids net(Kg)',
    defectiveQuantity:'Quantité Défectueuse',
    otherOccupation:'Autre Occupation',
    availableQuantity:'Quantité Disponible',
    changeTime:'Temps de Changement',
    landline:'Téléphone Fixe',
    fax:'Fax',
    address:'Adresse',
    bankOfAccount:'Banque de Compte',
    bankAccountNumber:'Numéro de Compte Bancaire',
    taxNum:'Numéro Fiscal',
    //提示
    operationSuccessful:'Opération Réussie',
    pleaseAddProduct:'Veuillez Ajouter un Produit',
    unitNotBeNull:'La Quantité et le Prix Unitaire Ne Peuvent Pas Être Vides',
    quantityNotBeDecimal:'La Quantité Ne Peut Pas Être un Décimal',
    unitPriceNotBeNegative:'Le Prix Unitaire Ne Peut Pas Être Négatif',
}